export default __webpack_public_path__ + "static/media/moto-side-fill.788ecb4e.svg";